import React, { useEffect } from "react";
import "../../../assets/styles/pages/pricingCss/pricing.css";



import "react-phone-input-2/lib/bootstrap.css";
import AOS from "aos";
import AccordionPricing from "./AccordionPricing";
import PricingMain from "./PricingMain";
import PricingClient from "./PricingClient";

const Pricing = () => {

  useEffect(()=>{
    AOS.init({duration:2000});

   },[])


 

  return (
    <div className="pricing-main">
    
    <PricingMain/>

    <PricingClient/>

    <AccordionPricing/>

    </div>
  );
};

export default Pricing;
